/*
============================================================
ADD-ON BUILDER: SYSTEM TOTAL CALCULATION
------------------------------------------------------------
Core pricing engine for the add-on builder.

This script now supports:
- Dynamic base price (based on selected variant)
- Automatic selection of first available add-on variants
- Real-time syncing of all totals (main, sticky, base, add-ons)

Primary responsibilities:
1. Read the CURRENT selected base product variant
2. Determine base product price dynamically (not static)
3. Iterate through all add-on cards
4. Resolve selected variant for each add-on
5. Validate inventory availability
6. Calculate add-on totals (price * quantity)
7. Update all UI price displays in sync

Triggered by:
- Add-on checkbox changes
- Option dropdown changes
- Quantity changes
- Variant changes (via form input)
============================================================
*/

/*
============================================================
DEFAULT VARIANT INITIALIZATION
------------------------------------------------------------
Ensures each add-on loads in a VALID state on page load.

Instead of using the first variant (which may be out of stock),
this function:
- Finds the first AVAILABLE variant
- Updates dropdowns to match that variant

Result:
- No "unavailable" state on load
- Better UX and immediate interactivity
============================================================
*/

function setFirstAvailableVariant(card) {
  const product = JSON.parse(card.dataset.product);

  // find first available variant
  const availableVariant = product.variants.find(v => v.available);

  if (!availableVariant) return;

  // update selects to match this variant
  const selects = card.querySelectorAll('.addon-select');

  selects.forEach((select, index) => {
    const value = availableVariant.options[index];
    if (value) {
      select.value = value;
    }
  });
}

/*
============================================================
MAIN TOTAL CALCULATION FUNCTION
------------------------------------------------------------
Central function that:
- Calculates base product price (dynamic)
- Calculates all add-ons
- Updates all price displays

IMPORTANT:
Base price is now derived from the CURRENTLY SELECTED
variant using form data + product JSON.

This keeps:
- Product price
- Builder total
- Sticky total
all perfectly in sync.
============================================================
*/

function updateSystemTotal(){

/*
------------------------------------------------------------
BASE PRODUCT PRICE (DYNAMIC)
------------------------------------------------------------
Pulls current variant ID from the product form and finds
the matching variant in product JSON.

Replaces old static "product.price" approach.
------------------------------------------------------------
*/

let basePrice = 0;

// const form = document.querySelector('form[action="/cart/add"]');
const form = document.querySelector('[data-main-product-form] form');
const mainProductDataEl = document.getElementById('main-product-data');

if (form && mainProductDataEl) {
  const mainProduct = JSON.parse(mainProductDataEl.textContent);

  const formData = new FormData(form);
  const variantId = formData.get('id');

  const variant = mainProduct.variants.find(v => v.id == variantId);

  if (variant) {
    basePrice = variant.price;
  }
}

let addonsTotal = 0;
let total = basePrice;

/*
------------------------------------------------------------
ADD-ON LOOP
------------------------------------------------------------
Iterates through each add-on card and calculates:
- Selected variant
- Availability
- Quantity
- Line total
------------------------------------------------------------
*/

document.querySelectorAll('.addon-card').forEach(card => {

  const toggle = card.querySelector('.addon-toggle');
  const product = JSON.parse(card.dataset.product);

  let selectedOptions = [];

  card.querySelectorAll('.addon-select').forEach(select => {
    selectedOptions.push(select.value);
  });

  /*
  ------------------------------------------------------------
  VARIANT RESOLUTION
  ------------------------------------------------------------
  Matches selected dropdown values to the correct variant.

  Includes fallback for single-variant products.
  ------------------------------------------------------------
  */

  let variant;

  if (selectedOptions.length === 0) {
    // Single-variant fallback
    variant = product.variants[0];
  } else {
    variant = product.variants.find(v =>
      v.options.every((opt,i)=> opt === selectedOptions[i])
    );
  }

  const qtyInput = card.querySelector('.addon-quantity');
  const plusBtn = card.querySelector('.qty-plus');
  const minusBtn = card.querySelector('.qty-minus');

  /*
  ------------------------------------------------------------
  INVENTORY VALIDATION
  ------------------------------------------------------------
  Handles unavailable variants by:

  - Disabling checkbox + inputs
  - Resetting quantity
  - Showing warning message
  - Preventing invalid selections from being added

  This ensures data integrity AND clean UX.
  ------------------------------------------------------------
  */

  const warning = card.querySelector('.addon-warning');

  const isUnavailable = !variant || !variant.available;

  card.classList.toggle("addon-soldout", isUnavailable);

  // control warning (single source of truth)
  if(warning){
    warning.style.display = isUnavailable ? 'block' : 'none';
  }

  // quantity controls
  if(qtyInput){
    qtyInput.disabled = isUnavailable;
    if(isUnavailable) qtyInput.value = 1;
  }

  if(plusBtn) plusBtn.disabled = isUnavailable;
  if(minusBtn) minusBtn.disabled = isUnavailable;
  if(toggle) toggle.disabled = isUnavailable;

  if(toggle){
    toggle.disabled = isUnavailable;

    // force uncheck when unavailable
    if(isUnavailable){
      toggle.checked = false;
    }
  }

  // skip if not selected OR invalid
  if(!toggle.checked || !variant || !variant.available) return;

  const qty = parseInt(qtyInput.value) || 1;

  const lineTotal = variant.price * qty;

  addonsTotal += lineTotal;
  total += lineTotal;

});

/*
------------------------------------------------------------
UPDATE PRICE DISPLAY
------------------------------------------------------------
Synchronizes all visible pricing:

- Base system price (variant-driven)
- Add-ons subtotal
- System total
- Sticky total

All values now reflect REAL-TIME selections.
------------------------------------------------------------
*/

const formatted = '$' + (total / 100).toFixed(2);

const mainTotal = document.getElementById('system-total-price');
const stickyTotal = document.getElementById('system-total-sticky');

// base system price (NEW: dynamic)
const baseSystemEl = document.getElementById('base-system-price');

if (baseSystemEl) {
  baseSystemEl.innerText = '$' + (basePrice / 100).toFixed(2);
}

if(mainTotal) mainTotal.innerText = formatted;
if(stickyTotal) stickyTotal.innerText = formatted;

const addonsEl = document.getElementById('addons-total-price');
const addonsRow = document.getElementById('addons-row');

if(addonsEl){
  addonsEl.innerText = '$' + (addonsTotal / 100).toFixed(2);
}

if(addonsRow){
  addonsRow.style.display = addonsTotal > 0 ? 'flex' : 'none';
}

}

/*
============================================================
CUSTOM ADD TO CART HANDLER
------------------------------------------------------------
Overrides default Shopify add-to-cart behavior to support:

- Base product + multiple add-ons
- Variant resolution per add-on
- Quantity support
- Merging duplicate variants

All items are submitted in a SINGLE request.
============================================================
*/

document.addEventListener("click", function(e){

const btn = e.target.closest('button[name="add"]');
if(!btn) return;

let form = btn.closest('form[action="/cart/add"]');

if(!form){
  form = document.querySelector('[data-main-product-form] form');
  // form = document.querySelector('form[action="/cart/add"]');
}

if(!form) return;

e.preventDefault();
e.stopImmediatePropagation();

const formData = new FormData(form);

const baseVariant = formData.get('id');
const baseQty = parseInt(formData.get('quantity')) || 1;

let items = [
  {
    id: baseVariant,
    quantity: baseQty
  }
];

document.querySelectorAll('.addon-card').forEach(card => {

  const toggle = card.querySelector('.addon-toggle');

  if(!toggle.checked) return;

  const product = JSON.parse(card.dataset.product);

  let selectedOptions = [];

  card.querySelectorAll('.addon-select').forEach(select => {
    selectedOptions.push(select.value);
  });

  let variant;

  if (selectedOptions.length === 0) {
    variant = product.variants[0];
  } else {
    variant = product.variants.find(v =>
      v.options.every((opt,i)=> opt === selectedOptions[i])
    );
  }

  const qtyInput = card.querySelector('.addon-quantity');

  let qty = 1;

  if(qtyInput){
      qty = parseInt(qtyInput.value);
  }

  /*
  ------------------------------------------------------------
  DUPLICATE VARIANT MERGING
  ------------------------------------------------------------
  Prevents duplicate line items in cart by combining quantities.
  ------------------------------------------------------------
  */

  const existing = items.find(i => i.id === variant.id);

  if(existing){
     existing.quantity += qty;
  } else {
      items.push({
      id: variant.id,
      quantity: qty
  });
}

});

/*
Send multi-product cart request
*/

fetch('/cart/add.js',{
  method:'POST',
  headers:{'Content-Type':'application/json'},
  body:JSON.stringify({items})
})
.then(()=> window.location.href='/cart');

});

/*
============================================================
EVENT LISTENERS
------------------------------------------------------------
Triggers recalculation whenever relevant inputs change.

Also initializes:
- Default valid variants (important UX improvement)
- Initial pricing state
============================================================
*/

document.addEventListener('change', updateSystemTotal);
document.addEventListener('input', updateSystemTotal);

document.addEventListener("DOMContentLoaded", function(){

  // set valid default variants for all add-ons
  document.querySelectorAll('.addon-card').forEach(card => {
    setFirstAvailableVariant(card);
  });

  updateSystemTotal();

  document.querySelectorAll('.addon-toggle').forEach(el => {
    el.addEventListener('change', updateSystemTotal);
  });

});

/*
============================================================
QUANTITY CONTROL HANDLER
------------------------------------------------------------
Handles +/- buttons for add-ons.

Ensures:
- Minimum quantity = 1
- UI stays in sync
============================================================
*/

document.addEventListener("click", function(e){

const plusBtn = e.target.closest(".qty-plus");
const minusBtn = e.target.closest(".qty-minus");

if(!plusBtn && !minusBtn) return;

const card = e.target.closest(".addon-card");
if(!card) return;

const input = card.querySelector(".addon-quantity");
if(!input) return;

let value = parseInt(input.value || 1);

if(plusBtn){
  value++;
}

if(minusBtn && value > 1){
  value--;
}

input.value = value;

input.dispatchEvent(new Event("change", { bubbles:true }));

});

/*
============================================================
ADD-ON TOGGLE HANDLER
------------------------------------------------------------
Enables/disables quantity controls based on checkbox state.

If unchecked:
- Quantity resets to 1
- Inputs disabled
============================================================
*/

document.addEventListener("change", function(e){

  if(!e.target.classList.contains("addon-toggle")) return;

  const card = e.target.closest(".addon-card");
  if(!card) return;

  const inputs = card.querySelectorAll(".addon-quantity, .qty-plus, .qty-minus");

  inputs.forEach(el => {
    el.disabled = !e.target.checked;
  });

  if(!e.target.checked){
    const qty = card.querySelector(".addon-quantity");
    if(qty) qty.value = 1;
  }

  updateSystemTotal();

});

/*
============================================================
PAGESHOW HANDLER (BACK BUTTON FIX)
------------------------------------------------------------
Ensures UI state is restored correctly when navigating back
from the cart (browser cache restore).

Fixes:
- Disabled inputs
- Incorrect toggle states
============================================================
*/

window.addEventListener("pageshow", function(event){

  if(!event.persisted) return;

  document.querySelectorAll('.addon-card').forEach(card => {

    const toggle = card.querySelector('.addon-toggle');
    const qtyInput = card.querySelector('.addon-quantity');
    const plusBtn = card.querySelector('.qty-plus');
    const minusBtn = card.querySelector('.qty-minus');

    if(!toggle) return;

    const enabled = toggle.checked;

    if(qtyInput) qtyInput.disabled = !enabled;
    if(plusBtn) plusBtn.disabled = !enabled;
    if(minusBtn) minusBtn.disabled = !enabled;

  });

  updateSystemTotal();

});